import * as constants from "./../constants";
import { getDateInStringDDMMMYYYY, getAvatarStringFromName, getVehicleNumberValues, getVehicleNumberValuesDWeb } from "./utils/utils";
import { findArrayObject, pos_to_neg } from "../../utils/utils";
import * as logger from './../../logger';

  export const getTransactionHistory = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
      method: "GET",
      url: `/transaction-history/all?pageSize=${data.pageSize}&pageNo=${data.pageNo}${data.searchText?`&filter=${data.searchText}`:""}${data.type && data.type != 'all'?`&type=${data.type}`:""}${data.startDateEpoch?`&startDateEpoch=${data.startDateEpoch}`:""}${data.endDateEpoch?`&endDateEpoch=${data.endDateEpoch}`:""}`,
      data,
      success: (response) => populateTransactionHistory(response,data && data.merge ? data.merge : false),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
    }
  });
  export const getSinglePayment = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
      method: "GET",
      url: `/transaction-history/${data.entityType}/${data.transactionId}${data.entityId?`?entityId=${data.entityId}`:''}`,
      data,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
    }
  });
  export const getBankDetails = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
      method: "GET",
      url: `/bankdetails/${data.type}/${data.id}`,
      data,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
    }
  });
  export const addBankDetails = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
      method: "POST",
      url: `/bankdetails/others`,
      data,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
    }
  });
  export const editBankDetails = (bankId, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
      method: "PUT",
      url: `/bankdetails/` + bankId,
      data,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
    }
  });
  export const getPaymentLink = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
      method: "POST",
      url: `/user-payment/link`,
      data,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
    }
  });
  export const getPaymentInitiate = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
      method: "POST",
      url: `/user-payment/initiate`,
      data,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
    }
  });
  export const getPaymentStatus = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
      method: "GET",
      url: `/payment/${data.orderId}/status`,
      data,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
    }
  });
  export const getPaymentStatusV1 = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
      method: "GET",
      url: `/payment/${data.orderId}/status`,
      data,
      doNotDisplaySpinner: true,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
    }
  });
  export const markDefaultBank = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
      method: "PUT",
      url: `/bankdetails/${data.id}/default`,
      data,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
    }
  });
  export const GetPreferedPaymentModes = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
      method: "POST",
      url: `/preferred/payment-modes`,
      data,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
    }
  });
  export const ValidateThePayment = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
      method: "POST",
      url: `/payment/validate`,
      data,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
    }
  });
  export const checkIfscCode = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
      method: "GET",
      url: `https://ifsc.razorpay.com/${data}`,
      data,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
    }
  });
  const populateTransactionHistory = (response,merge) => {
    var payloadData = []
    if (response && response.status && response.status.code == 200 && response.response && response.response.transactions && response.response.transactions.length > 0) {
      let data = response.response.transactions;
      for (var i = 0; i < data.length; i++) {
        let value = data[i]
        if(value && value.entityType && value.entityType == 'FUEL_RECHARGE'){
          value.entityType = "fuelcard"
        }
        value.dateDisplay=value && value.date?getDateInStringDDMMMYYYY(value.date) : "";
        payloadData.push(value)
      }
    }
    return { type: constants.TRANSACTION_HISTORY, payload:{merge:merge,...response.response}};
  }


  const populateNoStateUpdate= (response) => {
    return { type: null, payload: null };
  }